import { ActionPlanItem } from '../ActionPlanItem'
import { Wrapper } from './ActionPlan.styles'
import { FC } from 'react'
import { ActionPlanProps } from './ActionPlan.types'

const ActionPlan: FC<ActionPlanProps> = ({ messages, handleAction }) => {
    return (
        <Wrapper data-testid="action-plan">
            {messages.map((message) => (
                <ActionPlanItem
                    key={message.id}
                    message={message}
                    onAction={() => handleAction(message)}
                />
            ))}
        </Wrapper>
    )
}

export default ActionPlan
